import { render, staticRenderFns } from "./bdConfig.vue?vue&type=template&id=e519963a&scoped=true"
import script from "./bdConfig.vue?vue&type=script&lang=js"
export * from "./bdConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e519963a",
  null
  
)

export default component.exports